/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Override_TitleInputs */



/**
* | output |
* | --- |
* | "Override table result as judge" |
*
* @param {Override_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const override_title = /** @type {((inputs?: Override_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Override_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Corriger le résultat de table en tant que juge")
	if (locale === "es") return /** @type {LocalizedString} */ ("Corregir resultado de mesa como juez")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Corrigir resultado de mesa como juiz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Correggi il risultato del tavolo come giudice")
	return /** @type {LocalizedString} */ ("Override table result as judge")
});